import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'translate',
    standalone: false
})
export class TranslatePipe implements PipeTransform {

  transform(value: string, args: any[]): string {
    if (translations[value]) {
      return translations[value];
    }
    return value;
  }

}

export const translations = {
  'home': 'Home',

  'configurazione': 'Configurazione',
  'anagrafica': 'Anagrafica',
  'presents': 'Sono presenti',

  'ruoli': 'Ruoli',
  'ruolo': 'Ruolo',
  'ruolo.create': 'Nuovo Ruolo',
  'ruolo.edit': 'Modifica Ruolo',
  'ruolo.show': 'Ruolo',
  'ruolo.list': 'Ruoli',
  'ruolo.create.info': 'Creazione di un nuovo ',
  'ruolo.edit.info': 'Modifica ruolo ',

  'contesti': 'Contesti',
  'contesto': 'Contesto',
  'contesto.create': 'Nuovo Contesto',
  'contesto.edit': 'Modifica Contesto',
  'contesto.show': 'Contesto',
  'contesto.list': 'Contesti',
  'contesto.create.info': 'Creazione di un nuovo ',
  'contesto.edit.info': 'Modifica contesto ',

  'contestiVisualizzatore': 'Contesti Visualizzatori',

  'fasce': 'Fasce',
  'fascia': 'Fascia',
  'fascia.create': 'Nuova Fascia',
  'fascia.edit': 'Modifica Fascia',
  'fascia.show': 'Fascia',
  'fascia.list': 'Fasce',
  'fascia.create.info': 'Creazione di una nuova ',
  'fascia.edit.info': 'Modifica fascia ',

  'ruoliGenerici': 'Ruoli Generici',
  'ruoliGestore': 'Ruoli Gestore',
  'ruoliManager': 'Ruoli Manager',
  'ruoliVisualizzati': 'Ruoli di altri contesti visualizzati',

  'utenti': 'Utenti',
  'utente': 'Utente',
  'utente.create': 'Nuovo Utente',
  'utente.edit': 'Modifica Utente',
  'utente.show': 'Utente',
  'utente.list': 'Utenti',
  'utente.create.info': 'Creazione di un nuovo ',
  'utente.edit.info': 'Modifica utente ',

  'tipigerarchia': 'Tipi Gerarchia',
  'tipogerarchia': 'Tipo Gerarchia',
  'tipogerarchia.filter.not.present': 'Non presente nel tipo Gerarchia',
  'tipogerarchia.create': 'Nuovo Tipo Gerarchia',
  'tipogerarchia.edit': 'Modifica Tipo Gerarchia',
  'tipogerarchia.show': 'Tipo Gerarchia',
  'tipogerarchia.list': 'Tipi Gerarchia',
  'tipogerarchia.create.info': 'Creazione di un nuovo ',
  'tipogerarchia.edit.info': 'Modifica tipo gerarchia',
  'tipientitaorganizzativa': 'Tipi Entita Organizzative',
  'tipoentitaorganizzativa': 'Tipo Entita Organizzativa',
  'tipoentitaorganizzativa.create': 'Nuovo Tipo Entita Organizzativa',
  'tipoentitaorganizzativa.edit': 'Modifica Tipo Entita Organizzativa',
  'tipoentitaorganizzativa.show': 'Tipo Entita Organizzativa',
  'tipoentitaorganizzativa.list': 'Tipi Entita Organizzativa',
  'tipoentitaorganizzativa.create.info': 'Creazione di un nuovo ',
  'tipoentitaorganizzativa.edit.info': 'Modifica tipo entita organizzativa',

  'tipientitaorganizzativaattributo': 'Attributi Tipo Entita Organizzative',
  'tipoentitaorganizzativaattributo': 'Attributo Tipo Entita Organizzativa',
  'tipoentitaorganizzativaattributo.create': 'Nuovo Attributo Tipo Entita Organizzativa',
  'tipoentitaorganizzativaattributo.edit': 'Modifica Attributo Tipo Entita Organizzativa',
  'tipoentitaorganizzativaattributo.show': 'Attributo Tipo Entita Organizzativa',
  'tipoentitaorganizzativaattributo.list': 'Attributi Tipo Entita Organizzativa',
  'tipoentitaorganizzativaattributo.create.info': 'Creazione di un nuovo ',
  'tipoentitaorganizzativaattributo.edit.info': 'Modifica attributo tipo entita organizzativa',

  'categorietipieo': 'Categorie Tipi Entita Organizzative',
  'categoriatipieo': 'Categoria',
  'categoriatipieo.create': 'Nuova Categoria',
  'categoriatipieo.edit': 'Modifica Categoria',
  'categoriatipieo.show': 'Categoria',
  'categoriatipieo.list': 'Categorie Tipi Entita Organizzative',
  'categoriatipieo.create.info': 'Creazione di una nuova ',
  'categoriatipieo.edit.info': 'Modifica categoria ',

  'tipigerarchiastruttura': 'Struttura Tipi Gerarchia',
  'tipogerarchiastruttura': 'Struttura Tipo Gerarchia',
  'tipogerarchiastruttura.create': 'Nuova Struttura Tipo Gerarchia',
  'tipogerarchiastruttura.edit': 'Modifica Struttura Tipo Gerarchia',
  'tipogerarchiastruttura.show': 'Struttura Tipo Gerarchia',
  'tipogerarchiastruttura.list': 'Struttura Tipi Gerarchia',
  'tipogerarchiastruttura.create.info': 'Creazione di una nuova ',
  'tipogerarchiastruttura.edit.info': 'Modifica struttura tipo gerarchia',

  'tipientitalocale': 'Tipi Entita Locale',
  'tipoentitalocale': 'Tipo Entita Locale',
  'tipoentitalocale.create': 'Nuovo Tipo Entita Locale',
  'tipoentitalocale.edit': 'Modifica Tipo Entita Locale',
  'tipoentitalocale.show': 'Tipo Entita Locale',
  'tipoentitalocale.list': 'Tipi Entita Locale',
  'tipoentitalocale.create.info': 'Creazione di un nuovo ',
  'tipoentitalocale.edit.info': 'Modifica tipo entita locale',
  'entitalocale': 'Entita Locale',
  'entitalocale.create': 'Nuova Entita Locale',
  'entitalocale.edit': 'Modifica Entita Locale',
  'entitalocale.show': 'Entita Locale',
  'entitalocale.list': 'Entita Locali',
  'entitalocale.create.info': 'Creazione di una nuova ',
  'entitalocale.edit.info': 'Modifica entita locale',
  'entitaorganizzative': 'Entita Organizzative',
  'entitaorganizzativa': 'Entita Organizzativa',
  'entitaorganizzativa.create': 'Nuova Entita Organizzativa',
  'entitaorganizzativa.edit': 'Modifica Entita Organizzativa',
  'entitaorganizzativa.validita.edit': 'Modifica Validità Entita Organizzativa',
  'entitaorganizzativa.show': 'Riepilogo Entita Organizzativa',
  'entitaorganizzativa.list': 'Entita Organizzative',
  'entitaorganizzativa.create.info': 'Creazione di una nuova ',
  'entitaorganizzativa.edit.info': 'Modifica  entita organizzativa',
  'gerarchie': 'Rami Gerarchia',
  'gerarchia': 'Ramo Gerarchia',
  'gerarchia.create': 'Nuovo Ramo Gerarchia',
  'gerarchia.edit': 'Modifica Ramo Gerarchia',
  'gerarchia.validita.edit': 'Modifica Validità Ramo Gerarchia',
  'gerarchia.show': 'Ramo Gerarchia',
  'gerarchia.list': 'Rami Gerarchia',
  'gerarchia.create.info': 'Creazione di un nuovo ',
  'gerarchia.edit.info': 'Modifica ramo gerarchia',
  'tree-wizard': 'Entita organizzativa in Gerarchia',
  'persone': 'Persone',
  'persona': 'Persona',
  'persona.create': 'Nuova Persona',
  'persona.edit': 'Modifica Persona',
  'persona.show': 'Persona',
  'persona.list': 'Elenco Persone',
  'persona.create.info': 'Creazione di una nuova persona ',
  'persona.edit.info': 'Modifica persona ',
  
  'ruoliAssegnatiMenu': 'Ruoli Assegnati',
  'ruoliutente': 'Assegnazioni ruolo a utente',
  'ruoloutente': 'Assegnazione ruolo a utente',
  'ruoloutente.create': 'Nuova Assegnazione',
  'ruoloutente.edit': 'Modifica Assegnazione',
  'ruoloutente.show': 'Riepilogo Assegnazione',
  'ruoloutente.list': 'Ruoli Assegnati',
  'ruoloutente.create.info': 'Creazione di una nuova assegnazione ',
  'ruoloutente.edit.info': 'Modifica assegnazione ',
  'ruoloutente.validita': 'Assegnazioni valide alla data',
  'ruolipersona': 'Assegnazioni ruolo a persona',
  'ruolopersona': 'Assegnazione ruolo a persona',
  'ruolipersona.provv': 'Gestione Assegnazione Ruolo Provvisorio',
  'ruolopersona.create': 'Nuova Assegnazione',
  'ruolopersona.edit': 'Modifica Assegnazione',
  'ruolopersona.show': 'Riepilogo Assegnazione',
  'ruolopersona.list': 'Ruoli Assegnati',
  'ruolopersona.create.info': 'Creazione di una nuova assegnazione ',
  'ruolopersona.edit.info': 'Modifica assegnazione ',
  'ruolopersona.validita': 'Assegnazioni valide alla data',
  
  'personaentitaorganizzativa': 'Assegnazione persona a entità organizzativa',
  'personaentitaorganizzativa.create': 'Nuova Assegnazione',
  'personaentitaorganizzativa.edit': 'Modifica Assegnazione',
  'personaentitaorganizzativa.show': 'Riepilogo Assegnazione',
  'personaentitaorganizzativa.list': 'Assegnazioni a Entita Organizzative',
  'personaentitaorganizzativa.create.info': 'Creazione di una nuova assegnazione ',
  'personaentitaorganizzativa.edit.info': 'Modifica assegnazione ',
  'personaentitaorganizzativa.validita': 'Assegnazioni valide alla data',
  'fasciaentitaorganizzativa': 'Assegnazione fasce a entità organizzativa',
  'fasciaentitaorganizzativa.create': 'Nuova Assegnazione Fascia',
  'fasciaentitaorganizzativa.edit': 'Modifica Assegnazione Fascia',
  'fasciaentitaorganizzativa.show': 'Riepilogo Assegnazione Fascia',
  'fasciaentitaorganizzativa.list': 'Assegnazioni Fasce a Entita Organizzative',
  'fasciaentitaorganizzativa.create.info': 'Creazione di una nuova assegnazione fascia',
  'fasciaentitaorganizzativa.edit.info': 'Modifica assegnazione fascia',
  'fasciaentitaorganizzativa.validita': 'Assegnazioni fasce valide alla data',

  'delega': 'Delega',
  'deleghe': 'Deleghe',
  'delega.list': 'Deleghe',
  'delega.edit': 'Crea Delega',

  'gerarchia.validita': 'Validità Ramo',
  'gerarchia.ricerca': 'Ricerca per codici o denominazioni',
  'gerarchia-tree': 'Gerarchia entità organizzative',
  'nuovo.istituto.sede.in.gerarchia': 'Nuovo istituto con sede in gerarchia',
  'nuovo.istituto.in.gerarchia': 'Nuovo istituto in gerarchia',
  'nuova.sedeprincipale.in.gerarchia': 'Nuova sede principale in gerarchia',
  'nuova.sedesecondaria.in.gerarchia': 'Nuova sede secondaria in gerarchia',
  'associazione.entita.in.gerarchia': 'Nuova associazione in gerarchia',
  'spostamento.ramo.in.gerarchia': 'Spostamento ramo in gerarchia',
  'disassociazione.ramo.in.gerarchia': 'Disassociazione ramo da gerarchia',
  'validita.entitaorganizzativa': 'Modifica validità entita organizzativa',
  'nuovaassociazione': 'Associa entità organizzativa esistente',
  "copia-associa": "Associa copiando da...",
  "cruscotto-ruoli-utente": "Cruscotto ruoli utente",

  'id': 'Id',
  'descr' : 'Descrizione',
  'nome': 'Nome',
  'cognome': 'Cognome',
  'sesso': 'Genere',
  'matricola': 'Matricola',
  'dataNascita': 'Data Nascita',
  'codiceFiscale': 'Codice Fiscale',
  'username': 'Username',
  'tipoContratto': 'Tipo Contratto',
  'contratto': 'Contratto',
  'livello': 'Livello',
  'profilo': 'Profilo',
  'livelloProfilo': 'Livello/Profilo',
  'scadAccount': 'Scadenza Account',
  'ultimoAccesso': 'Ultimo Accesso',
  'indirizzoUltimoAccesso': 'Indirizzo Ultimo Accesso',
  'dipendente': 'Dipendente',
  'inizioValidita': 'Inizio Validità',
  'fineValidita': 'Fine Validità',
  'denominazione': 'Denominazione',
  'denominazioneBreve': 'Den. Breve',
  'sigla': 'Sigla',
  'idnsip': 'Id NSIP',
  'cdsuo': 'Cdsuo',
  'subIdnsip': 'Id NSIP',
  'subCdsuo': 'Cdsuo',
  'carattere': 'Carattere',
  'figlioGuida': 'Figlio Guida',
  'guida': 'Guida',
  'provvedimento': 'Provvedimento',
  'indennita': 'Indennita',
  'importoIndennita': 'Importo',
  'soal': 'SAOL',
  'gestioneSoal': 'Gestione SAOL',
  'note': 'Note',
  'admin': 'Admin',
  'tipoAppartenenza': 'Tipo Appartenenza',
  'codiceIstat': 'Codice Istat',
  'indirizzoPrincipale': 'Indirizzo Principale',
  'altriIndirizzi': 'Altri Indirizzi',
  'civico': 'Civico',
  'comune': 'Comune',
  'cap': 'Cap',
  'localita': 'Localita',
  'entitaOrganizzative': 'Entita Organizzative',
  'tipiEntitaOrganizzativa': 'Tipi entita organizzativa',
  'tipologia': 'Tipologia',
  'indirizzo': 'Indirizzo',
  'dataCessazione': 'Data Cessazione',
  'sede': 'Sede',
  'entitaLocale': 'Entita Locale',
  'categoria': 'Categoria',
  'utilizzo': 'Utilizzo',
  'tipoGerarchia': 'Tipo Gerarchia',
  'padre': 'Padre',
  'figlio': 'Figlio',
  'entitaOrganizzativa': 'Entita Organizzativa',
  'entitaOrganizzativaDaCopiare': 'Entita Organizzativa da copiare',
  'chiudiEntitaCopiata': 'Chiudi entita copiata',
  'dataDisassociazione': 'Data Disassociazione',
  'dataSpostamento': 'Data Spostamento',
  'tipo': 'Tipo',
  'modifica': 'Modifica',
  'ordine': 'Ordine',
  'nuovoInizioValidita': 'Nuovo Inizio Validità',
  'nuovaFineValidita': 'Nuova Fine Validità',
  'via': 'Via',
  'comuneestero': 'Comune Estero',
  'nazione': 'Nazione',
  'presso': 'Presso',
  'email': 'Email',
  'inattivo': 'Inattivo',
  'attivo': 'Attivo',
  'attachments': 'Allegati',
  'attachment': 'Allegato',
  'assegnabileGlobalmente': 'Assegnabile a livello Globale',
  'ruoliAssociati': 'Ruoli associati al gruppo',
  'ruoliAssegnati': 'Ruoli assegnati al gruppo',
  'ruoliGruppoAssegnati': 'Assegnato ai gruppi',
  'ruoloPadre' : 'Ruolo Padre',
  'pec': 'Pec',
  'sitoweb': 'Sito Web',
  'telefono': 'Telefono',
  'telefono2': 'Telefono 2',
  'telefono3': 'Telefono 3',
  'telefonoUfficio': 'Telefono',
  'fax': 'Fax',
  'fasciaRequired': 'Associa Fascia',
  
  'M': 'Uomo',
  'F': 'Donna',
  'SEDE': 'Sede',
  'AFFERENZA_UO': 'Afferenza UO',
  'TEMPO_INDETERMINATO': 'Tempo indeterminato',
  'TEMPO_DETERMINATO': 'Tempo determinato',
  'TRIMESTRALE': 'Trimestrale',
  'CONTRATTO_LAVORO_DIR_PRIVATO': 'Contratto lavoro dir privato',
  'PERSONALE_COMANDATO_ESTERNO': 'Personale comandato esterno',
  'ASSOCIATO_PRE_PROVV_N_83_2016': 'Associato pre-Provv. n.83/2016',
  'DOTTORANDO':'Dottorando',
  'BORSISTA':'Borsista',
  'ASSEGNISTA':'Assegnista',
  'SPECIALIZZANDO': 'Specializzando',
  'INCARICATO_DI_RICERCA':'Incaricato di ricerca',
  'PROFESSORE_VISITATORE':'Professore visitatore',
  'COLLABORATORE_PROFESSIONALE':'Collaboratore professionale',
  'SALARIATO_AGRICOLO':'Salariato agricolo',
  'ALTRO':'Altro',
  'DIRETTORE_NON_DIPENDENTE_CNR':'Direttore non dipendente CNR',
  'STAGE':'Stage',
  'TIROCINANTE':'Tirocinante',
  'ANALISTA_DI_LABORATORIO':'Analista di laboratorio',
  'SUPPORTO_INFORMATICO':'Supporto informatico',
  'ATTIVITA_DI_FORMAZIONE':'Attivita di formazione',
  'OPERATORE_HELP_DESK':'Operatore help-desk',
  'DIPENDENTE_IMT':'Dipendente IMT',
  'ASSOCIATO_CON_INCARICO_DI_RICERCA':'Associato con incarico di ricerca',
  'ASSOCIATO_CON_INCARICO_DI_COLLABORAZIONE':'Associato con incarico di collaborazione',
  'ASSOCIATO_CON_INCARICO_DI_COLLABORAZIONE_SENIOR':'Associato con incarico di collaborazione senior',
  'DIPENDENTE_IN_COMANDO_DA_ALTRA_AMMINISTRAZIONE_SENZA_ONERI':'Dipendente in comando da altra amministrazione senza oneri',
  'DIRETTORE_CONSORZIO_RFX':'Direttore Consorzio RFX',
  'REFERENTE_PARTECIPATA':'Referente partecipata',
  'PERSONALE_IN_COMANDO':'Personale in Comando',
  'MEMBRO_CDA':'Membro CDA',
  'MEMBRO_COMMISSIONE_DI_VALUTAZIONE':'Membro commissione di valutazione',
  'DIRIGENTE_IN_COMANDO':'Dirigente in comando',
  'ASSOCIATO_CON_INCARICO_DI_RICERCATORE_EMERITO':'Associato con incarico di ricercatore emerito',
  'not_assigned': 'Non assegnato',
  'true': 'Si',
  'false': 'No',
  'TRUE': 'Dipendenti',
  'FALSE': 'Non Dipendenti',
  'stato.ruolo.persona.P': 'Provvisorio',
  'stato.ruolo.persona.D': 'Definitivo',
  'stato.ruolo.persona.E': 'Non lavorabile',
  'stato': 'Stato',
  'dataConsolidamento': 'Data Consolidamento',

  'cancel': 'Annulla',
  'save': 'Salva',
  'back': 'Indietro',
  'new': 'Nuovo',
  'delete': 'Elimina',
  'edit': 'Modifica',
  'remove': 'Rimuovi',
  'add': 'Aggiungi',
  'csv': 'Estrai dati in csv',

  'noLavorabile': 'Non Lavorabile',
  'consolida': 'Consolida',
  
  'required': 'Obbligatorio',
  'UniqueValidator': 'Deve essere unico',
  'minlength': 'Lunghezza minima non raggiunta',
  'maxlength': 'Lunghezza massima superata',
  'nsip.info': 'Vuoto oppure codice di 6 caratteri',
  'cdsuo.info': 'Vuoto oppure codice di 6 caratteri',

  'no_item': 'Non sono presenti elementi.',
  'present': 'Presenti',
  'shown_from': 'Mostrate dalla',
  'shown_to': 'alla',
  'occurrences': 'occorrenze',
  'search': 'Cerca',
  'previous': 'Indietro',
  'next': 'Avanti',

  'tipoRuolo': 'Tipologia',
  'ROLE_USER': 'Utente Applicativo',
  'ROLE_SUPERUSER': 'SuperUtente Applicativo',
  'ROLE_ANONYMOUS': 'Utente Anonimo Applicativo',
  'ROLE_ADMIN': 'Amministratore Applicativo',
  'ROLE_GENERIC': 'Ruolo Generico',
  'GESTORE_CONTESTO': 'Gestore del Contesto',
  'MANAGER_CONTESTO': 'Manager del Contesto',
  'ROLE_GROUP': 'Gruppo di Ruoli',
  'firstName': 'Nome',
  'lastName': 'Cognome',
  'helpdesk.create': 'HelpDesk',
  'helpdesk.create.info': 'Apri una nuova segnalazione '
}

//   'tree-wizard': 'Nuova entita organizzativa in gerarchia',
